// extracted by mini-css-extract-plugin
export var Support = "index-module--Support--RjD42";
export var contentTitle = "index-module--contentTitle--81Q0Q";
export var contentWrap = "index-module--contentWrap--HkhQQ";
export var pageBottom = "index-module--pageBottom--O7G5y";
export var standardTitle = "index-module--standardTitle--P+v3p";
export var standardWrap = "index-module--standardWrap--nnT9Y";